import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { HelperService } from 'src/app/helpers/helper.service';
import { PathRoutes } from 'src/app/routes/path-routes';
import { AccountService } from 'src/app/services/account.service';
import { SessionService } from 'src/app/services/session.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-register-user-info',
  templateUrl: './register-user-info.component.html',
  styleUrls: ['./register-user-info.component.scss']
})
export class RegisterUserInfoComponent implements OnInit {
  PathRoutes = PathRoutes
  form: FormGroup
  addressForm: FormGroup
  maritals = []
  loading = false
  ufs = []
  session: any
  genders = [
    { id: 'masculino', name: 'Masculino' },
    { id: 'feminino', name: 'Feminino' },
  ]
  state: any
  terms = false
  user: any
  dependents: any

  constructor(
    public helper: HelperService,
    private router: Router,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private sessionService: SessionService,
    private userService: UsersService,
    private activatedRoute: ActivatedRoute
  ) {
    this.state = this.router.getCurrentNavigation().extras.state
  }

  ngOnInit(): void {
    this.dependents = this.activatedRoute.snapshot.queryParams['dependents']
    this.ufs = this.helper.ufs
    // this.user = this.sessionService.getRegister()
    this.session = this.sessionService.getSession()
    this.setupForm()
    this.getMaritals()
  }

  checkAge(e) {
    const now = moment()
    const diff = now.diff(moment(e.target.value), 'years')
    if (diff < 18) {
      this.form.get('birthdate').setErrors({ incorrect: true })
    }
  }

  async getMaritals() {
    try {
      let res = await this.userService.maritalStatus()
      this.maritals = res.map(e => ({ ...e, name: e.title }))
    } catch (error) {
      console.log(error)
    }
  }

  setupForm() {
    this.addressForm = this.formBuilder.group({
      'street': ['', Validators.required],
      'street_number': ['', Validators.required],
      'neighborhood': ['', Validators.required],
      'city': ['', Validators.required],
      'state': ['', Validators.required],
      'zipcode': ['', Validators.required],
      'complementary': [''],
    })

    this.form = this.formBuilder.group({
      'rg': ['', Validators.required],
      'landline': ['', Validators.required],
      'marital': ['', Validators.required],
      'profession': ['', Validators.required],
      'gender': ['', Validators.required],
      'birthdate': ['', Validators.required],
      'address': this.addressForm
    })
  }

  cepComplete() {
    if (this.addressForm.get('zipcode').value.length == 8) {
      return this.accountService.getCep(this.addressForm.get('zipcode').value)
        .then(res => {

          var uf = this.ufs.filter(r => r.id == res.uf)[0]?.id

          this.addressForm.patchValue({
            street: res.logradouro,
            neighborhood: res.bairro,
            city: res.localidade,
            state: uf,
            // complement: res.complemento
          });
        })
        .catch(error => {
          console.log(error)
          this.addressForm.get('zipcode').setValue(null)
        });
    }
  }

  async save() {
    this.loading = true
    let register = this.sessionService.getRegister()
    let params = { ...register, info: this.form.getRawValue() }
    console.log(params)
    this.sessionService.saveRegister(params)
    setTimeout(() => {
      console.log(this.dependents)
      if (this.dependents > 0) {
        this.router.navigate([PathRoutes.Register.Dependents], { queryParams: { dependents: this.dependents } })
      } else {
        this.router.navigate([PathRoutes.Register.Payment])
      }
      this.loading = false
    }, 1000);
  }

  logout() {
    this.sessionService.destroySession()
    this.router.navigate([PathRoutes.Login])
  }
}
